module.exports = __webpack_public_path__ + "static/media/spark.f931c816.svg";